import React,{useEffect} from 'react';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import 'photoswipe/dist/photoswipe.css';
import {Gallery} from "react-photoswipe-gallery";
import { useMediaQuery } from '@mui/material';
import LiegenLayout from './LiegenLayout';
import useSharedDocHeader from './DocHeaderHook';
import { useTranslation } from 'react-i18next';
import { imagesXS ,imagesMD,imagesSM} from './LiegenData';

export default function Liegen() {
  const {doSetTitleKey,doSetMetaDescKey} = useSharedDocHeader();

  const { t } = useTranslation(['common','materials','media']);

  useEffect(() => {
    doSetTitleKey('categoryLabel:CATEGORY_LABEL_liegen');
    doSetMetaDescKey('categoryMetaDesc:CATEGORY_DESC_liegen');
  },[]);

  const captionTextHTLM = (title,mediaKey,materialKey,sizeVal) => {
    let titleRet = "<h6 style='line-height:60%'>" +t("common:TITLE") + ":" + title + "</h6>";
    const materialVal = t("materials:" + materialKey);
    const materialRet = !!(materialVal)?"<h6 style='line-height:60%'>"+t("common:MATERIAL") + ":" + materialVal + + "</h6>" :null;
    const mediaVal = t("media:" + mediaKey);
    const mediaRet = !!(mediaVal)?"<h6 style='line-height:60%'>" + t("common:MEDIA") + ":" + mediaVal + "</h6>":null;
    const sizeRet = !!(sizeVal)?"<h6 style='line-height:60%'>" + t("common:LABEL_SIZE") + ":" + sizeVal + "</h6>":null;
    return titleRet + mediaRet + materialRet + sizeRet;
  };
  
  const isSm = useMediaQuery('(min-width:620px)', { noSsr: true });
  const isMd = useMediaQuery('(min-width:1100px)', { noSsr: true });

  return (
    <Grid2 height="100vh" container display="flex" spacing={2} flexDirection="column" sx={{alignItems:'center',flexGrow :1,bgcolor: 'background.paper'}}>
      <Grid2 width="100vw" display="flex" flexDirection="row" spacing={2} sx={{pt:6,alignItems:'center',justifyContent:'center',flexGrow :1,bgcolor: 'background.paper'}}>
        <Gallery withCaption id='liegen'>
          {isMd?<LiegenLayout captionFN={captionTextHTLM} data={imagesMD}/>:isSm?<LiegenLayout captionFN={captionTextHTLM} data={imagesSM} />:<LiegenLayout captionFN={captionTextHTLM} data={imagesXS}/>}
        </Gallery>
      </Grid2>
    </Grid2>
  )
}
